import React, { useState, useEffect, useRef } from 'react';

const TeamSearchSelector = ({
  placeholder,
  items,
  onSelect,
  initialItem = null,
  displayProperty = 'name',
  idProperty = 'id',
  imageProperty = 'image',
  setTeams,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialItem);
  const selectorRef = useRef(null);

  useEffect(() => {
    if (initialItem) {
      setSelectedItem(initialItem);
    }
  }, [initialItem]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    filterResults(query);
  };

  const filterResults = (query) => {
    if (!query) {
      setSearchResults(items); // Show all items when query is empty
      return;
    }

    const results = items.filter(item =>
      item[displayProperty].toLowerCase().includes(query.toLowerCase())
    );
    setSearchResults(results);
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setSearchQuery('');
    setShowResults(false);
    onSelect(item);
  };

  const handleClear = () => {
    setSelectedItem(null);
    setSearchQuery('');
    setShowResults(false);
    onSelect(null);
    setTeams(prev => [...prev, selectedItem]);
  };

  const handleFocus = () => {
    setSearchResults(items); // Show all items on focus
    setShowResults(true);
  };

  return (
    <div className="search-selector" ref={selectorRef}>
      {!selectedItem ? (
        <div className="search-box">
          <input
            type="text"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            onFocus={handleFocus}
          />

          {showResults && (
            <div className="search-results">
              {searchResults.map(item => (
                <div
                  key={item[idProperty]}
                  className="search-result-item"
                  onClick={() => handleSelectItem(item)}
                >
                  {item[imageProperty] && (
                    <img
                      src={item[imageProperty]}
                      alt={item[displayProperty]}
                      className="result-image"
                      onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
                    />
                  )}
                  <span>{item[displayProperty]}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="selected-item">
          <div className="selected-content">
            {selectedItem[imageProperty] && (
              <img
                src={selectedItem[imageProperty]}
                alt={selectedItem[displayProperty]}
                className="selected-image"
                onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
              />
            )}
            <span>{selectedItem[displayProperty]}</span>
          </div>
          <button type="button" className="clear-button" onClick={handleClear}>
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default TeamSearchSelector;
